import React, { Component } from "react";
import {
  HelpBlock,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { Colors }               from "../utils/Colors";
//import { WhiteLabel }        from "../utils/WhiteLabelProps";

//WhiteLabel();
/*
import {
  AuthenticationDetails,
  CognitoUserPool
} from "amazon-cognito-identity-js"; // old login code
*/

import { Auth } from "aws-amplify"; // new login code

import config from "../config";
import "../css/Signup.css";

export default class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      confirmPassword: "",
      confirmationCode: "",
      newUser: null
    };
  }

  validateForm() {
    return (
      this.state.email.length > 0 &&
      this.state.password.length > 0 &&
      this.state.password === this.state.confirmPassword
    );
  }

  validateConfirmationForm() {
    return this.state.confirmationCode.length > 0;
  }

  handleChange = event => {
        this.setState({
          [event.target.id]: event.target.value
        });
  }

  handleSubmit = async event => {
      event.preventDefault();

      this.setState({ isLoading: true });

      try {
        //old: const newUser = await this.signup(this.state.email, this.state.password);
        const newUser = await Auth.signUp({
            username: this.state.email,
            password: this.state.password
        });

        this.setState({
          newUser: newUser
        });
      } catch (e) {
        alert("Signup error: " + e);
      }

      this.setState({ isLoading: false });
    }

    handleConfirmationSubmit = async event => {
      event.preventDefault();

      this.setState({ isLoading: true });

      try {
        /*old code: await this.confirm(this.state.newUser, this.state.confirmationCode);
        await this.authenticate(
          this.state.newUser,
          this.state.email,
          this.state.password
       );*/
            await Auth.confirmSignUp(this.state.email, this.state.confirmationCode);
            await Auth.signIn(this.state.email, this.state.password);


            this.props.userHasAuthenticated(true);
            this.props.history.push("/login");
        } catch (e) {
            alert("Signup error: " + e);
            this.setState({ isLoading: false });
        }
    }

    /*signup(email, password) {
      const userPool = new CognitoUserPool({
        UserPoolId: config.cognito.USER_POOL_ID,
        ClientId: config.cognito.APP_CLIENT_ID
      });

      return new Promise((resolve, reject) =>
        userPool.signUp(email, password, [], null, (err, result) => {
          if (err) {
            reject(err);
            return;
          }

          resolve(result.user);
        })
      );
    }*/

    confirm(user, confirmationCode) {
      return new Promise((resolve, reject) =>
        user.confirmRegistration(confirmationCode, true, function(err, result) {
          if (err) {
            reject(err);
            return;
          }
          resolve(result);
        })
      );
    }

    /*authenticate(user, email, password) {
      const authenticationData = {
        Username: email,
        Password: password
      };
      const authenticationDetails = new AuthenticationDetails(authenticationData);

      return new Promise((resolve, reject) =>
        user.authenticateUser(authenticationDetails, {
          onSuccess: result => resolve(),
          onFailure: err => reject(err)
        })
      );
    }*/

  renderConfirmationForm() {
    return (
      <form onSubmit={this.handleConfirmationSubmit}>
        <FormGroup controlId="confirmationCode" bsSize="large">
          <ControlLabel>Confirmation Code</ControlLabel>
          <FormControl
              autoFocus
              type="tel"
              value={this.state.confirmationCode}
              onChange={this.handleChange}
          />
          <HelpBlock>Please check your email for the code.</HelpBlock>
        </FormGroup>
        <LoaderButton
              block
              bsSize="large"
              disabled={!this.validateConfirmationForm()}
              type="submit"
              isLoading={this.state.isLoading}
              btncolor  = { Colors.ok_button_bg }
              fontSize  = {20}
              height    = {40}
              text="Verify"
              loadingText="Verifying…"
        />
      </form>
    );
  }

  renderForm() {
    return (
      <form onSubmit={this.handleSubmit}>
        <FormGroup controlId="email" bsSize="large">
          <ControlLabel>Email</ControlLabel>
          <FormControl
            autoFocus
            type="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="large">
          <ControlLabel>Password</ControlLabel>
          <FormControl
            value={this.state.password}
            onChange={this.handleChange}
            type="password"
          />
        </FormGroup>
        <FormGroup controlId="confirmPassword" bsSize="large">
          <ControlLabel>Confirm Password</ControlLabel>
          <FormControl
            value={this.state.confirmPassword}
            onChange={this.handleChange}
            type="password"
          />
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateForm()}
          type="submit"
          isLoading={this.state.isLoading}
          btncolor  = { Colors.ok_button_bg }
          fontSize  = {20}
          height    = {40}
          text="Signup"
          loadingText="Signing up…"
        />
      </form>
    );
  }

  render() {
    return (
      <div className="Signup">
        {this.state.newUser === null
          ? this.renderForm()
          : this.renderConfirmationForm()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Signup.js